import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {Text} from '@/components/ui/text/Text'
import {useGetAbsences} from '../../queries/useGetAbsences'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useFormContext, useWatch} from 'react-hook-form'
import {CreateAbsenceFormValidationSchema} from '../../formSchemas'
import dayjs from 'dayjs'
import {useTranslation} from '@/translations/i18n'

export const MissedAccessesDisplay = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<CreateAbsenceFormValidationSchema>()
    const date = useWatch({control, name: 'date'})
    const project = useWatch({control, name: 'project'})

    const {data: absences, isLoading: isLoadingAbsences} = useGetAbsences({
        params: {
            page: 1,
            limit: 99999,
            startDate: dayjs(date).format('YYYY-MM-DD'),
            endDate: dayjs(date).format('YYYY-MM-DD'),
            projectId: project?.id
        },
        options: {
            enabled: !!date && !!project
        }
    })

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{t('accesses:missed_accesses')}</Label>
            <Flexbox align="center" fullWidth style={{height: '32px'}}>
                {isLoadingAbsences ? (
                    <Skeleton width="100%" height="20px" />
                ) : (
                    <Text size="textSm" palette="neutral" shade="600">
                        {absences && absences?.length > 0 ? absences?.length : '-'}
                    </Text>
                )}
            </Flexbox>
        </Flexbox>
    )
}
